import * as _ from "lodash";
import { ElementType } from "../IProcessData";
import { IMigrationParameters } from ".";
import { remoteCallDictionaryName, remoteCallParameterName } from '../../components/CallActivity/CallActivityRemoteExecutionEditor';
import { ParameterEditorValue } from "../ParameterEditorValue";
import { ParameterEditorMode } from "processEditor/components/ParameterInput";

export function migrate(migrateParameters: IMigrationParameters) {
    const element = migrateParameters.element;
    if (element &&
        element.type === ElementType.GlobalErrorHandler ||
        element.type === ElementType.CallActivity &&
        element.parameters[remoteCallDictionaryName] !== undefined &&
        element.parameters[remoteCallParameterName] != null &&
        element.parameters[remoteCallParameterName] == true) {

        const parameterCopy = Object.assign({}, element.parameters);
        const remoteCallDictionary: Record<string, string | ParameterEditorValue> = parameterCopy[remoteCallDictionaryName];
        for (const environmentName in remoteCallDictionary) {
            const currentAgentGroup: string | null | ParameterEditorValue = remoteCallDictionary[environmentName];

            // Skip migration if remoteCallDestination is already a ParameterEditorValue
            if (hasDestinationBeenMigrated(currentAgentGroup)) {
                continue;
            }

            const newMigratedEditorValue: ParameterEditorValue = {
                mode: ParameterEditorMode[ParameterEditorMode.select],
                value: currentAgentGroup
            }
            remoteCallDictionary[environmentName] = newMigratedEditorValue
        }

        const migratedElement = Object.assign({}, element, { parameters: parameterCopy });
        return migratedElement;
    }
    return element;
}

const hasDestinationBeenMigrated = (remoteCallDestination: string | null | ParameterEditorValue): remoteCallDestination is ParameterEditorValue => {
    if (remoteCallDestination === null) {
        return true;
    }
    return (remoteCallDestination as ParameterEditorValue).value !== undefined;
}